import React from 'react';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-beige overflow-hidden pl-[0px] pr-[0px] space-y-[28px] pt-[7px] pb-[7px] mt-[0px] mb-[0px]" data-id="element-209">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 pt-[0px] pb-[0px] mt-[0px] mb-[0px] space-y-[17px]" data-id="element-210">
        <div className="flex flex-col items-center" data-id="element-211">
          {/* Text Content */}
          <div className="max-w-2xl mx-auto text-center pt-[0px] pb-[0px] space-y-[11px] mt-[0px] mb-[0px]" data-id="element-212">
            <div className="inline-block bg-white px-3 py-1 rounded-full font-semibold tracking-wider text-gold uppercase border border-gold/20 text-[12px] pt-[4px] pb-[4px] mt-[0px] mb-[0px]" data-id="element-213">
              El sistema N°1 para propietarios que construyen en Argentina
            </div>

            <h1 className="lg:text-6xl font-bold text-balance text-[28px] pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px]" data-id="element-214">
              Todo tu año de obra.
              <br data-id="element-215" />
              <span className="text-gold" data-id="element-216">Listo. Desde hoy.</span>
            </h1>

            {/* Image - placed below the heading */}
            <div className="relative" data-id="element-217">
              <div className="absolute inset-0 bg-gold/10 rounded-full blur-3xl transform scale-90" data-id="element-218"></div>
              <img src="https://cdn.magicpatterns.com/uploads/gcEofi79xC4PjNSraaKL7N/MockUp_MegaPack_Arquitectura_Argentina_sin_fondo.png" alt="Colección Arquitectura Argentina - Zentral Pro" className="relative z-10 w-full max-w-lg mx-auto drop-shadow-2xl pt-[0px] pb-[0px] pl-[5px] pr-[5px] mt-[0px] mb-[0px] ml-[0px] mr-[0px]" data-id="element-219" />
            </div>

            <p className="text-gray-700 max-w-lg mx-auto font-[500] text-[14px] pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[4px] mr-[4px]" data-id="element-220">
              Del terreno a la llave sin perder plata, sin improvisar, sin que
              te tomen de sorpresa.
            </p>

            <div className="flex flex-nowrap pt-[0px] pb-[0px] flex-row items-center justify-center pl-[0px] pr-[0px] mt-[5px] mb-[5px] ml-[0px] mr-[0px] gap-[3px]" data-id="element-221">
              <span className="inline-flex items-center gap-1 bg-white px-2 py-1 rounded-md font-medium border border-beige-dark shadow-sm text-[10px] whitespace-nowrap" data-id="element-222">
                📄 100% PDF
              </span>
              <span className="inline-flex items-center gap-1 bg-white px-2 py-1 rounded-md font-medium border border-beige-dark shadow-sm text-[10px] whitespace-nowrap" data-id="element-223">
                ⚡ 5 min
              </span>
              <span className="inline-flex items-center bg-white px-2 py-1 rounded-md font-medium border border-beige-dark shadow-sm text-[10px] gap-1 whitespace-nowrap" data-id="element-224">
                🇦🇷 35m²→95m²
              </span>
              <span className="inline-flex items-center gap-1 bg-white px-2 py-1 rounded-md font-medium border border-beige-dark shadow-sm text-[10px] whitespace-nowrap" data-id="element-225">
                🏗️ Todas las etapas
              </span>
            </div>

            <div className="pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[3px] mr-[3px] pt-[0px] pb-[0px]" data-id="element-226">
              <a href="#precios" className="block w-full sm:w-auto text-center bg-gold hover:bg-gold-light text-white font-bold py-4 px-8 rounded-sm shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 text-[14px] pt-[15px] pb-[15px] pl-[33px] pr-[33px] mt-[9px] mb-[9px]" data-id="element-227">
                🏗️ → QUIERO MI PACK CI 6×6 AHORA
              </a>
            </div>

            <div className="flex text-sm text-gray-600 pt-[2px] pb-[2px] mt-[4px] mb-[4px] gap-[25px] items-start justify-center" data-id="element-228">
              <div className="flex items-center gap-1.5" data-id="element-229">
                <Shield className="w-4 h-4 text-gold" data-id="element-230" />
                <span className="text-[12px]" data-id="element-231">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-232">
                <Lock className="w-4 h-4 text-gold" data-id="element-233" />
                <span className="text-[12px]" data-id="element-234">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-235">
                <CreditCard className="w-4 h-4 text-gold" data-id="element-236" />
                <span className="text-[12px] font-[400]" data-id="element-237">Mercado Pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}